import { PageTitleKey } from "config/common";

import { ICommonTranslation } from "models/translation";

import { ListItemTranslator } from "helpers/translationHelpers";
import { fallbackTranslation } from "services/api/fallbackData";

export function getPageTitle(
  commonTranslation: ICommonTranslation,
  pageTitleKey: PageTitleKey,
  customReplace?: (template: string) => string
): string {
  const translator = new ListItemTranslator(
    commonTranslation?.pages?.pageTitles,
    fallbackTranslation.common.pages.pageTitles
  );
  const translation = translator.get(pageTitleKey);

  return translation.replace(
    translation,
    customReplace?.(translation) ?? translation
  );
}
